module.exports = __webpack_public_path__ + "img/2.97ce5b11.png";